// Copyright 2018-2024 the Deno authors. All rights reserved. MIT license.
// Copyright the Browserify authors. MIT License.
// Ported from https://github.com/browserify/path-browserify/
// This module is browser compatible.

export function stripTrailingSeparators(
  segment: string,
  isSep: (char: number) => boolean,
): string {
  if (segment.length <= 1) {
    return segment;
  }

  let end = segment.length;

  for (let i = segment.length - 1; i > 0; i--) {
    if (isSep(segment.charCodeAt(i))) {
      end = i;
    } else {
      break;
    }
  }

  return segment.slice(0, end);
}

// denoCacheMetadata={"headers":{"x-jsr-cache-status":"hit","server":"UploadServer","cache-control":"public, max-age=31536000, immutable","x-robots-tag":"noindex","x-goog-storage-class":"STANDARD","cross-origin-resource-policy":"cross-origin","via":"1.1 google","age":"230","content-type":"text/typescript","access-control-allow-origin":"*","etag":"\"4f57deda21d8130960095805a8fe4059\"","content-security-policy":"default-src 'none'; script-src 'none'; style-src 'none'; img-src 'none'; font-src 'none'; connect-src 'none'; frame-src 'none'; object-src 'none'; frame-ancestors 'none'; sandbox; form-action 'none';","x-goog-hash":"crc32c=fukxxw==,md5=T1fe2iHYEwlgCVgFqP5AWQ==","last-modified":"Fri, 01 Nov 2024 10:38:02 GMT","x-goog-stored-content-length":"592","x-content-type-options":"nosniff","x-goog-generation":"1730457482883089","content-length":"592","alt-svc":"h3=\":443\"; ma=2592000,h3-29=\":443\"; ma=2592000","x-jsr-cache-id":"IAD","x-goog-metageneration":"1","accept-ranges":"bytes","expires":"Sat, 08 Nov 2025 10:06:11 GMT","access-control-expose-headers":"*","date":"Fri, 08 Nov 2024 10:06:11 GMT","x-goog-stored-content-encoding":"identity","x-guploader-uploadid":"AHmUCY3KtyIdx6qQFp-3u4Vc6fo_0Lejw5LdJsBN1AjyxxCkMmDVqF6X-noHfYFFCYSRm_qFehI"},"url":"https://jsr.io/@std/path/1.0.8/_common/strip_trailing_separators.ts","time":1731060601}